import { createAPI } from '@common'
export default {
    // 授权情况概览
    getDeployOverview: config => createAPI('customEncryptApiName-1/0w20efqmpz0pwfswjfx', 'GET', config)
}
